import React from "react";

const DATA: Array<{ feature: string; ca: string; cpa: string }> = [
  {
    feature: "Governing Body",
    ca: "ICAI (Institute of Chartered Accountants of India)",
    cpa: "AICPA (American Institute of CPAs) & State Boards",
  },
  {
    feature: "Global Recognition",
    ca: "Limited (India & some Gulf countries)",
    cpa: "Global (Especially USA, Canada, UAE)",
  },
  {
    feature: "Course Duration",
    ca: "4.5-6 years",
    cpa: "12-18 months",
  },
  {
    feature: "Number of Exams",
    ca: "3 Levels (CA Foundation, Inter, Final)",
    cpa: "3 Core (FAR, AUD, REG) + 1 Discipline (BAR, ISC, or TCP)",
  },
  {
    feature: "Internship",
    ca: "3-year Articleship (Mandatory)",
    cpa: "1-2 years of experience post-exam",
  },
  {
    feature: "Pass Percentage",
    ca: "~5-15% (Final)",
    cpa: "~50% for each section",
  },
  {
    feature: "Avg. Salary (India)",
    ca: "₹8-12 LPA (1-3 years)",
    cpa: "₹10-20 LPA (CPA India)",
  },
  {
    feature: "Avg. Salary (USA)",
    ca: "Not applicable",
    cpa: "$70,000-$130,000+",
  },
  {
    feature: "Flexibility",
    ca: "Sequential, rigid path",
    cpa: "Modular, can fast-track",
  },
];

/* Borders, header tint and the hairline shadow are the demo table's, so the two
   comparison tables read as one component across the CMA and CPA pages. */
const CELL = "px-2.5 py-3.5 text-left leading-[1.35] md:px-3 md:py-4";
const DESKTOP_CELL = `${CELL} align-top text-[14px]`;
const MOBILE_CELL = `${CELL} align-middle text-[14px]`;
const WRAPPER =
  "overflow-hidden rounded-[8px] border border-[#C0C7D5] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]";
const ROW_RULE = "border-t border-[#C0C7D5]";

const CaVsCpaComparison = () => {
  return (
    <section className="w-full bg-white md:py-[50px] max-md:bg-[#F3F3F3] max-md:pb-4">
      <div className="main_container">
        <div className="max-md:rounded-2xl max-md:bg-white max-md:px-4 max-md:py-4">
          <h2 className="text-[24px] md:text-[32px] font-bold leading-[1.3] text-left md:text-center">
            <span className="text-[#39F]">CPA vs CA:</span>{" "}
            <span className="text-[#333]">A Quick Comparison</span>
          </h2>

          {/* ── Desktop: features run as columns, the two credentials as rows ── */}
          <div className={`mt-6 hidden md:mt-8 md:block ${WRAPPER}`}>
            {/* Fixed layout so ten columns keep their proportions instead of
                being sized by whichever cell holds the longest sentence. */}
            <table className="w-full table-fixed border-collapse">
              <thead>
                <tr className="bg-[#E8EFF9]">
                  <th
                    className={`${DESKTOP_CELL} w-[11%] font-semibold text-[#161C22]`}
                  >
                    Feature
                  </th>
                  {DATA.map((d) => (
                    <th
                      key={d.feature}
                      className={`${DESKTOP_CELL} font-semibold text-[#161C22]`}
                    >
                      {d.feature}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className={ROW_RULE}>
                  <th
                    scope="row"
                    className={`${DESKTOP_CELL} font-semibold text-[#161C22]`}
                  >
                    CA (India)
                  </th>
                  {DATA.map((d) => (
                    <td
                      key={d.feature}
                      className={`${DESKTOP_CELL} font-medium text-[#333]`}
                    >
                      {d.ca}
                    </td>
                  ))}
                </tr>
                <tr className={ROW_RULE}>
                  <th
                    scope="row"
                    className={`${DESKTOP_CELL} font-semibold text-[#161C22]`}
                  >
                    CPA (USA)
                  </th>
                  {DATA.map((d) => (
                    <td
                      key={d.feature}
                      className={`${DESKTOP_CELL} font-medium text-[#333]`}
                    >
                      {d.cpa}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          {/* ── Mobile: the same table transposed, features back down the side ── */}
          <div className={`mt-5 md:hidden ${WRAPPER}`}>
            <table className="w-full table-fixed border-collapse">
              <thead>
                <tr className="bg-[#E8EFF9]">
                  <th
                    className={`${MOBILE_CELL} w-[34%] font-semibold text-[#161C22]`}
                  >
                    Feature
                  </th>
                  <th
                    className={`${MOBILE_CELL} text-center font-semibold text-[#161C22]`}
                  >
                    CA (India)
                  </th>
                  <th
                    className={`${MOBILE_CELL} text-center font-semibold text-[#161C22]`}
                  >
                    CPA (USA)
                  </th>
                </tr>
              </thead>
              <tbody>
                {DATA.map((d) => (
                  <tr key={d.feature} className={ROW_RULE}>
                    <th
                      scope="row"
                      className={`${MOBILE_CELL} font-semibold text-[#161C22]`}
                    >
                      {d.feature}
                    </th>
                    <td
                      className={`${MOBILE_CELL} text-center font-medium text-[#333]`}
                    >
                      {d.ca}
                    </td>
                    <td
                      className={`${MOBILE_CELL} text-center font-medium text-[#333]`}
                    >
                      {d.cpa}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaVsCpaComparison;
